module.exports = __webpack_public_path__ + "static/logo-starship-ae21500b66fd431bfc9b74326208728a.png";